import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject, input } from "@angular/core";
import { RoutingService } from "@skylab-angular-shared/core";
import { TranslatePipe } from "@skylab-angular-shared/pipes";
import { ButtonComponent } from '@skylab-angular-shared/ui';
import { AppStates, ConfigurationParametersViews } from "@skylab-shared/scenes";

@Component({
	selector: 'skl-fiscal-suz-errors-toast-component',
	template: `
		<div>{{text()}}</div>
		<ul>
			@for (message of messages(); track message) {
				<li>{{message}}</li>
			}
		</ul>
		<skl-button
			data-type="frame"
			(click)="onRedirect()"
		>
			{{'scenes.shared.toast.fiscalization.mapping-error.go-to-configuration' | translate}}
		</skl-button>
	`,
	styles: `
		:host {
			display: flex;
			flex-direction: column;
			gap: var(--gutter-small);
			font-size: .9rem;
			color: var(--text-minor-color);
		}
	`,
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [TranslatePipe, ButtonComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FiscalMappingErrorToastComponent {
	readonly #routingService = inject(RoutingService);

	public readonly dismiss = input<() => void>();
	public readonly text = input<string>();
	public readonly messages = input<string[]>();
	public readonly printerId = input<number>();

	public onRedirect(): void {
		this.#routingService.navigate([AppStates.configurationParameters.url], { queryParams: { view: ConfigurationParametersViews.Fiscalization, id: this.printerId() } });
		this.dismiss()?.();
	}
}
